
export const stagesName = {
    size: "size",
    covering: "covering",
    armrests: "armrests",
    base: "base",
    options: "options",
}

export const tagName = {
    fabric: "fabric",
    leather: "leather"
}

export const stageTextByStageName = (id: string, messages?: Record<string, string>) => {
    switch(id){
        case stagesName.size:
            return messages?.page_size.toLowerCase();
        case stagesName.covering:
            return messages?.page_coating.toLowerCase();
        case stagesName.armrests:
            return messages?.page_arm.toLowerCase();
        case stagesName.base:
            return messages?.page_foot.toLowerCase();
        case stagesName.options:
            return messages?.page_comfort.toLowerCase();
    }
}

export const translatedTag = (tag?: string, messages?: Record<string, string>) => {
    switch(tag){
        case tagName.fabric:
            return messages?.coating_fabric;
        case tagName.leather:
            return messages?.coating_leader;
        default:
            return messages?.coating_fabric;
    }
}
